module.exports = __webpack_public_path__ + "static/media/wikimedia.b0248393.png";